import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/img/logo-ai-caption-round.png'
import _imports_1 from '../../assets/img/icons/twitter.svg'


const _withScopeId = n => (_pushScopeId("data-v-57314fca"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "responsive-navbar offcanvas offcanvas-end border-0",
  "data-bs-backdrop": "static",
  tabindex: "-1",
  id: "navbarOffcanvas"
}
const _hoisted_2 = { class: "offcanvas-header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo-light",
  src: _imports_0,
  alt: "Image",
  width: "60"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo-dark",
  src: _imports_0,
  width: "60",
  alt: "Image"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "close-btn bg-transparent lh-1 p-0",
  "data-bs-dismiss": "offcanvas",
  "aria-label": "Close"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "ri-close-line" })
], -1))
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"offcanvas-body\" data-v-57314fca><ul class=\"responsive-menu mobile-menu\" data-v-57314fca><li class=\"responsive-menu-list nav-item\" data-v-57314fca><a href=\"#hero-area\" class=\"nav-link\" data-v-57314fca>Home</a></li><li class=\"responsive-menu-list nav-item\" data-v-57314fca><a href=\"#about-area\" class=\"nav-link\" data-v-57314fca>About</a></li><li class=\"responsive-menu-list nav-item\" data-v-57314fca><a href=\"#feature-area\" class=\"nav-link\" data-v-57314fca>Feature</a></li><li class=\"responsive-menu-list nav-item\" data-v-57314fca><a href=\"#download-area\" class=\"nav-link\" data-v-57314fca>Donwload</a></li><li class=\"responsive-menu-list nav-item\" data-v-57314fca><a href=\"#footer-area\" class=\"nav-link\" data-v-57314fca>Contact</a></li></ul><div class=\"other-option d-md-flex align-items-center\" data-v-57314fca><ul class=\"social-profile list-style text-md-center\" data-v-57314fca><li data-v-57314fca><a href=\"https://twitter.com/cdev_le\" target=\"_blank\" data-v-57314fca><img src=\"" + _imports_1 + "\" alt=\"Twitter\" data-v-57314fca></a></li></ul></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: "/",
        class: "logo d-inline-block"
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _hoisted_4
        ]),
        _: 1
      }),
      _hoisted_5
    ]),
    _hoisted_6
  ]))
}